import { useEffect } from "react";
import { hasIubendaConsent, IUBENDA_CONSENT_EVENT, waitForIubendaApi } from "@/lib/iubendaConsent";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    __gtmLoaded?: boolean;
  }
}

function loadGtm(containerId: string) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__gtmLoaded) return;
  if (document.querySelector(`script[data-gtm-container="${containerId}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
  script.dataset.gtmContainer = containerId;
  document.head.appendChild(script);

  window.__gtmLoaded = true;
}

export default function GtmLoader() {
  useEffect(() => {
    const containerId = (import.meta.env.VITE_GTM_ID as string | undefined)?.trim();
    if (!containerId) return;

    const syncGtmWithConsent = () => {
      if (hasIubendaConsent()) loadGtm(containerId);
    };

    syncGtmWithConsent();
    const stopWaiting = waitForIubendaApi(syncGtmWithConsent);
    window.addEventListener(IUBENDA_CONSENT_EVENT, syncGtmWithConsent as EventListener);

    return () => {
      stopWaiting();
      window.removeEventListener(IUBENDA_CONSENT_EVENT, syncGtmWithConsent as EventListener);
    };
  }, []);

  return null;
}
